import { TrackingObjectVoter } from "./TrackingObjectVoter";

export class ExpenseVoter extends TrackingObjectVoter {
  trackingObjectClass = "Expense";

  lockOptionKey = "lock_expense_after_days";
}
